import makeSlice from '@web/slices/paymentMethod/sliceMaker'

import {initOrderSheetByAPI} from '../../actions/familyPay'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initOrderSheetByAPI.fulfilled, (state, {payload}) => {
            const {
                data: {payMethod, verifyServerClientData},
                availablePayMethodTypes,
            } = payload

            state.availableTypes = availablePayMethodTypes

            state.statements = payMethod.payMethodStatement.payMethodStatementsByExposureAreaType
            state.errorExposureArea = payMethod.payMethodStatement.exposureAreaTypes
            state.verifyServerClientData = verifyServerClientData

            /** 자동결제 결제수단 등록된 경우  */
            if (payMethod.defaultPayment) {
                const {payMethodType} = payMethod.defaultPayment

                state.selected.prevPayMethod = payMethodType
                state.selected.payMethods = [payMethodType]
            }
        })
    },
})

export default slice.reducer
